import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

import routes from "./routes";

export const SIDEBAR_ITEMS = [
  {
    id: "packages",
    label: "Packages",
    icon: Inventory2OutlinedIcon,
    path: routes.packages.root,
    match: (pathname) => pathname === routes.packages.root,
  },
  {
    id: "coupons",
    label: "Coupons",
    icon: LocalOfferOutlinedIcon,
    path: routes.coupons.list,
    match: (pathname) => pathname.startsWith("/coupons"),
  },
  {
    id: "uploads",
    label: "Uploads",
    icon: CloudUploadOutlinedIcon,
    path: routes.uploads.root,
    match: (pathname) => pathname === routes.uploads.root,
  },
];
